module.exports = __webpack_public_path__ + "static/media/logo.07ff0800.png";